<script setup>
import { useLayout } from '@/layout/composables/layout';
import { useThemeSetting } from '@/layout/composables/theme';
import { SettingService } from '@/service/SettingService';
import { updatePreset, updateSurfacePalette } from '@primevue/themes';
import { onBeforeMount } from 'vue';

const settingService = SettingService.INSTANCE;
const { primaryColors, surfaces, getPresetExtColor } = useThemeSetting();
const { switchOnDarkMode } = useLayout();

const initialPreset = () => {
    const primaryColor = primaryColors.value.find((c) => c.name === settingService.getPrimaryTheme());
    const presetColor = getPresetExtColor(primaryColor);
    updatePreset(presetColor);
};

const initialSurface = () => {
    const surfacePalette = surfaces.value.find((s) => s.name === settingService.getSurfaceTheme())?.palette;
    updateSurfacePalette(surfacePalette);
};

onBeforeMount(() => {
    initialPreset();
    initialSurface();
    switchOnDarkMode();
});
</script>

<template>
    <div>
        <Toast />
        <Toast draggable="false" error-icon="pi pi-times-circle" group="desktop" info-icon="pi pi-info-circle" position="top-right" success-icon="pi pi-check-circle" warn-icon="pi pi-exclamation-circle" />
        <Toast draggable="false" error-icon="pi pi-times-circle" group="mobile" info-icon="pi pi-info-circle" position="top-center" success-icon="pi pi-check-circle" warn-icon="pi pi-exclamation-circle" />
        <router-view v-slot="{ Component }">
            <component :is="Component" />
        </router-view>
    </div>
</template>

<style scoped></style>
